import {Col, Row} from "antd";
import styled from "styled-components";

export const PickupInformationContainer = styled(Row)`
    width: 100%;
    border-bottom: 1px dashed #c6c5c5;
    padding: 20px 0;
    flex-direction: column;
    gap: 20px !important;
`;

export const PickupInformationHeader = styled(Col)`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-weight: bold;
`;

export const PickupInformationTitle = styled(Col)`
    font-size: 18px;
    margin-left: 7px;
`;

export const CreditLabel = styled.div`
    font-size: 30px;
    font-weight: 900;
    line-height: initial;
`;
